import jwtDecode from 'jwt-decode'
import axios from './axios'

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false
  }
  const decoded = jwtDecode<{exp: number}>(accessToken)

  const currentTime = Date.now() / 1000

  return decoded.exp > currentTime
}

export const getUserName = (accessToken: string) => {
  if (!accessToken) {
    return ''
  }
  const decoded = jwtDecode<{name: string}>(accessToken)

  return decoded.name
}

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('Name', getUserName(accessToken))
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken.replace(/["]/g, '')}`
  } else {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('Name')
    delete axios.defaults.headers.common.Authorization
  }
}
